var getSessionId = function getSessionId(appName) {
  return appName + Math.random().toString(16).slice(2);
};
export { getSessionId };